module.exports = __webpack_public_path__ + "static/img/fly.63f1ab85.png";